module.exports = __webpack_public_path__ + "img/bare_nails_logo.4db05a99.png";